// Libs
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

// Utils
import { PATHS } from '~fpu/config/constants';

interface EveryDollarTrialActivation {
  claimMethod: 'app' | 'email';
}

function useEveryDollarTrialActivation() {
  return useMutation({
    mutationFn: (payload: EveryDollarTrialActivation) =>
      axios.post(PATHS.API.EVERYDOLLAR_TRIAL_ACTIVATION, payload),
    throwOnError: true
  });
}

function useEveryDollarSubExtension() {
  return useMutation({
    mutationFn: (payload: EveryDollarTrialActivation) =>
      axios.post(PATHS.API.EVERYDOLLAR_SUB_EXTENSION, payload),
    throwOnError: true
  });
}

export { useEveryDollarTrialActivation, useEveryDollarSubExtension };
